
import { Component, Vue, VModel, Prop, Watch } from 'vue-property-decorator';
import Avatar from '@/components/common/avatar/Avatar.vue';
import { ProjectManager, UserDTO } from '@/models';
import { Getter } from '@/decorators';
import { cloneDeep } from 'lodash';

interface UserOption {
  text: string | number;
  value: UserDTO;
}

const headers = [
  { text: 'Avatar', value: 'avatarUrl' },
  { text: 'Email', value: 'user.email' },
  { text: 'Name', value: 'user.fullName' },
  { text: 'KMS ID', value: 'user.code' },
  { text: 'Status', value: 'status' },
  // { text: 'Role', value: 'user.role' },
  { text: '-', value: 'actions', align: 'end' }
];
@Component({
  components: {
    Avatar
  }
})
export default class ProjectManagerEditDialog extends Vue {
  @Getter('user/users')
  users: UserDTO[];

  @VModel()
  dialog!: boolean;

  @Prop()
  projectManagers!: ProjectManager[];

  selectedProjectManagers: ProjectManager[] = [];

  headers = headers;

  selectedUser: UserDTO | null = null;

  filterUsers(item: UserOption, queryText: string): boolean {
    const { value = { fullName: '' } } = item;
    const text = value.fullName.toString().toLowerCase();
    const query = queryText.toLowerCase();
    return text.indexOf(query) > -1;
  }

  get userOptions(): UserOption[] {
    return cloneDeep(this.users)
      .filter(u => !this.selectedProjectManagers.some(sm => sm?.user?.id === u?.id))
      .map(u => ({
        text: u.id,
        value: u
      }));
  }

  onProjectManagerSelected(item: ProjectManager): void {
    if (!item) {
      return;
    }
    const selectedUser = cloneDeep(this.selectedProjectManagers.find(pm => pm?.user?.id === item?.id));

    if (!selectedUser) {
      const manager = {
        user: item
      } as unknown as ProjectManager;

      this.selectedProjectManagers.push(manager);
      this.selectedUser = null;
    }
  }

  onProjectManagerSelectedDeleted(item: UserDTO): void {
    const foundUser = this.selectedProjectManagers.find(pm => pm?.user?.id === this.selectedUser?.id);
    if (foundUser) {
      this.selectedUser = null;
    }
    this.selectedProjectManagers = cloneDeep(this.selectedProjectManagers.filter(pm => pm?.user?.id !== item?.id));
  }

  onProjectManagerSelectedApplied(): void {
    this.dialog = false;
    this.$emit(
      'updateManagers',
      this.selectedProjectManagers?.map(u => u?.user)
    );
  }

  onCancel(): void {
    this.selectedProjectManagers = cloneDeep(this.projectManagers);
    this.dialog = false;
  }

  mounted(): void {
    this.selectedProjectManagers = cloneDeep(this.projectManagers);
  }
}
